import { render, staticRenderFns } from "./Substrate.vue?vue&type=template&id=af6fff8a&"
import script from "./Substrate.vue?vue&type=script&lang=js&"
export * from "./Substrate.vue?vue&type=script&lang=js&"
import style0 from "./Substrate.vue?vue&type=style&index=0&id=af6fff8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports